module.exports = __webpack_public_path__ + "img/tg.35ab8a26.svg";